<template>
  <a-drawer
    v-model:open="open"
    class="custom-class"
    root-class-name="root-class-name"
    :width="modalWidth"
  >
    <template #title>
      <div>
        <span class="text-xl font-bold">
          {{ $t("Pos.CustomerSaleInfo") }}
        </span>
      </div>
    </template>

    <a-row>
      <a-col :span="12" >
        <span class="font-semibold">{{ $t("Pos.Date") }} : </span>
        <span class="text-sm">{{ formatDate(sale.created_at) }}</span>
      </a-col>
    </a-row>
    <a-row class="mt-2">
      <a-col :span="12" v-if="sale.order_number !== null">
        <span class="font-semibold">{{ $t("Pos.Order") }} : </span>
        <span class="text-sm">{{ sale.order_number }}</span>
      </a-col>

      <a-col :span="12">
        <span class="font-semibold">{{ $t("Pos.TotalPrice") }} : </span>
        <span class="text-sm">{{
          formatAmount(sale.total, currencyCode, decimalPrecision)
        }}</span>
      </a-col>
      
    </a-row>
    <a-row class="mt-2">
      <a-col :span="12">
        <span class="font-semibold">{{ $t("Pos.DiscountType") }} : </span>
        <span v-if="sale.discount_type == 'percentage'"
          ><a-tag>{{ $t("Pos.Percentage") }}</a-tag></span
        >
        <span v-if="sale.discount_type == 'amount'"
          ><a-tag>{{ $t("Pos.Amount") }}</a-tag></span
        >
        <span v-if="sale.discount_type == 'fixed'"
          ><a-tag>{{ $t("Pos.Fixed") }}</a-tag></span
        >
      </a-col>
      <a-col :span="12">
        <span class="font-semibold">{{ $t("Pos.Discount") }} : </span>
        <span class="text-sm">{{
          formatAmount(sale.discount_value, currencyCode, decimalPrecision)
        }}</span>
      </a-col>
    </a-row>
    <a-row class="mt-4">
      <a-col :span="24">
        <template v-for="(sales, id) in sale.items" :key="id">
          <a-descriptions bordered size="small" class="mb-2">
            <a-descriptions-item :label="$t('Pos.Name')" :span="3">{{
              sales.product.name
            }}</a-descriptions-item>
            <template v-if="sales.discount_value!=null">
              <a-descriptions-item :label="$t('Pos.Discount')" :span="1">
                <CheckCircleTwoTone two-tone-color="#52c41a" />
              </a-descriptions-item>

            <a-descriptions-item :label="$t('Pos.Amount')" :span="2">{{
              formatAmount(sales.discount_value, currencyCode, decimalPrecision)
            }}</a-descriptions-item> 
            </template>
            <template v-else>
              <a-descriptions-item :label="$t('Pos.Discount')" :span="3">
                <CloseCircleTwoTone two-tone-color="#ff4d4f" />
              </a-descriptions-item>
            </template>
            <a-descriptions-item :label="$t('Pos.Quantity')" :span="1">{{
              sales.quantity
            }}</a-descriptions-item>
            <a-descriptions-item :label="$t('Pos.Price')" :span="2">{{
              formatAmount(
                sales.product.full_price,
                currencyCode,
                decimalPrecision
              )
            }}</a-descriptions-item>
          </a-descriptions>
        </template>
      </a-col>
    </a-row>
  </a-drawer>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  defineProps,
  onMounted,
  onUnmounted,
  ref,
  watch,
  defineEmits,
} from "vue";
import { currency } from "@/_helpers";
import dayjs from "dayjs";
import {

  CheckCircleTwoTone,
  CloseCircleTwoTone,
} from "@ant-design/icons-vue";

export default defineComponent({
  name: "LbrxSaleDrawer",
  components: {
    CheckCircleTwoTone,
    CloseCircleTwoTone,
  },
});
</script>
<script setup lang="ts">


const props = defineProps<{
  open: boolean;
  sale: any;
  currencyCode: string;
  decimalPrecision: number;
}>();

const emit = defineEmits<{
  (e: "update:open", value: boolean): void;
}>();

const open = ref(props.open);
watch(
  () => props.open,
  (newValue) => {
    open.value = newValue;
  }
);
watch(open, (newValue) => {
  emit("update:open", newValue);
});
const windowWidth = ref(window.innerWidth);

const modalWidth = computed(() => {
  // extra small devices
  if (windowWidth.value < 576) {
    return "100%";
  }
  // small devices
  else if (windowWidth.value >= 576 && windowWidth.value < 768) {
    return "60%";
  }
  // medium devices
  else if (windowWidth.value >= 768 && windowWidth.value < 992) {
    return 320;
  }
  // large devices
  else if (windowWidth.value >= 992 && windowWidth.value < 1200) {
    return 420;
  }
  // extra large devices
  else {
    return 600;
  }
});

const handleResize = () => {
  windowWidth.value = window.innerWidth;
};

const formatAmount = (
  amount: any,
  currencyCode: any,
  decimalPrecision: any
) => {
  return currency.formatAmount(amount, currencyCode, decimalPrecision);
};

const formatDate = (date: any) => {
  return dayjs(date).format("DD-MM-YYYY HH:mm");
};

onMounted(() => {
  window.addEventListener("resize", handleResize);
});

onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
});
</script>

